import React, { useState, useEffect } from "react";
import 'animate.css';
import { Container, Row, Col, Card } from "react-bootstrap";
import { FaHandSparkles, FaSprayCan, FaBroom, FaTrash, FaHome, FaClock, FaLayerGroup, FaBrush } from "react-icons/fa";
import playstore from "../../Images/google-play.jpg";
import leftimage from "../../Images/sweepydo_image1.png";
import rightimage from "../../Images/sweepydo_image5.png";
import mobile from "../../Images/mobileApp.png";
import image1 from "../../Images/sweepydo_image9.jpg";
import image2 from "../../Images/sweepydo_image17.jpg";
import image3 from "../../Images/sweepydo_image16.jpg";
import image4 from "../../Images/sweepydo_image11.jpg";
import image5 from "../../Images/sweepydo_image8.jpg";
import image6 from "../../Images/sweepydo_image19.jpg";
const features = [{
  icon: <FaHandSparkles />,
  title: "Germ Control"
}, {
  icon: <FaSprayCan />,
  title: "Eco-Friendly"
}, {
  icon: <FaBroom />,
  title: "Quick Service"
}, {
  icon: <FaTrash />,
  title: "Clutter-Free"
}, {
  icon: <FaHome />,
  title: "Deep Cleaning"
}, {
  icon: <FaClock />,
  title: "Time Saving"
}, {
  icon: <FaLayerGroup />,
  title: "Organized Order"
}, {
  icon: <FaBrush />,
  title: "Dust Elimination"
}];
const stats = [{
  number: "10Y",
  label: "EXPERIENCE"
}, {
  number: "20K",
  label: "SERVICES COMPLETED"
}, {
  number: "4.8/5",
  label: "CUSTOMERS RATING"
}, {
  number: "1.1M",
  label: "SATISFIED CUSTOMERS"
}];
const services = [{
  title: "Kitchen Cleaning",
  image: image1
}, {
  title: "Window Cleaning",
  image: image2
}, {
  title: "Utensil Cleaning",
  image: image3
}, {
  title: "Bathroom Cleaning",
  image: image4
}, {
  title: "Sweeping Cleaning",
  image: image5
}, {
  title: "Dusting",
  image: image6
}];
function Home() {
  const [leftOffset, setLeftOffset] = useState(0);
  const [rightOffset, setRightOffset] = useState(0);
  const [leftAnimated, setLeftAnimated] = useState(false);
  const [rightAnimated, setRightAnimated] = useState(false);
  useEffect(() => {
    setLeftAnimated(true);
    setRightAnimated(true);
  }, []);
  useEffect(() => {
    let leftPos = 0;
    let rightPos = 0;
    let leftDir = 1;
    let rightDir = -1;
    const speed = 1.5;
    const maxDistance = 50;
    const animate = () => {
      leftPos += speed * leftDir;
      rightPos += speed * rightDir;
      if (leftPos > maxDistance || leftPos < -maxDistance) leftDir = -leftDir;
      if (rightPos > maxDistance || rightPos < -maxDistance) rightDir = -rightDir;
      setLeftOffset(leftPos);
      setRightOffset(rightPos);
      requestAnimationFrame(animate);
    };
    requestAnimationFrame(animate);
  }, []);
  return <>
      

        <section style={{
      minHeight: "70vh",
      marginTop: "0",
      background: "linear-gradient(to bottom, #f2f2f2 70%, #916bb4 100%)",
      borderBottomLeftRadius: "30px",
      borderBottomRightRadius: "30px",
      position: "relative",
      overflow: "visible",
      paddingTop: "0",
      paddingBottom: "270px"
    }}>
      
    
        <img src={leftimage} alt="maid-left" style={{
        position: "absolute",
        left: "20px",
        bottom: "0",
        width: "20vw",
        maxWidth: "300px",
        height: "auto",
        objectFit: "contain",
        transform: `translateX(${leftOffset}px)`,
        animationName: leftAnimated ? "slideInLeft" : "none",
        animationDuration: "1s",
        animationTimingFunction: "ease-out",
        animationFillMode: "forwards"
      }} />

     
        <img src={rightimage} alt="maid-right" style={{
        position: "absolute",
        right: "20px",
        bottom: "0",
        width: "20vw",
        maxWidth: "300px",
        height: "auto",
        objectFit: "contain",
        transform: `translateX(${rightOffset}px)`,
        animationName: rightAnimated ? "slideInRight" : "none",
        animationDuration: "1s",
        animationTimingFunction: "ease-out",
        animationFillMode: "forwards"
      }} />

   
        <style>
          {`
            @keyframes slideInLeft { 0% { transform: translateX(-150%); opacity:0 } 100% { transform: translateX(0); opacity:1 } }
            @keyframes slideInRight { 0% { transform: translateX(150%); opacity:0 } 100% { transform: translateX(0); opacity:1 } }

            @media (max-width: 768px) {
              img[alt="maid-left"], img[alt="maid-right"] {
                width: 30vw !important;
                height: auto !important;
              }
              h1 { font-size: clamp(28px,6vw,48px) !important; }
              p { font-size: clamp(14px,4vw,18px) !important; }
              img[alt="mobile"] { width: 50vw !important; bottom: -80px !important; }
            }
          `}
        </style>

        <Container className="text-center" style={{
        zIndex: 5,
        position: "relative"
      }}>
          <h1 className="animate__animated animate__fadeInUp" style={{
          fontSize: "64px",
          fontWeight: "700",
          lineHeight: "1.1",
          marginTop: "0px"
        }}>
            Trusted house help in <br /> minutes!
          </h1>

          <div className="d-flex justify-content-center my-4" style={{
          color: "#666",
          fontSize: "20px",
          marginTop: "20px"
        }}>
            <p className="animate__animated animate__fadeInUp">Download the app now</p>
          </div>
{/* 
          <div className="d-flex justify-content-center my-4">
            
            <img
              src={playstore}
              alt="Google Play"
              style={{
                width: "200px",
                maxWidth: "50vw",
                height: "auto",
                cursor: "pointer",
                borderRadius: "10px",
                transition: "transform 0.3s ease",
              }}
              onMouseEnter={e => (e.currentTarget.style.transform = "scale(1.1)")}
              onMouseLeave={e => (e.currentTarget.style.transform = "scale(1)")}
            />
          </div> */}
          <div className="d-flex justify-content-center my-4">
  <a href="https://play.google.com/store/apps/details?id=com.dectwinservices.sweepydo&pcampaignid=web_share" target="_blank" rel="noopener noreferrer">
    <img src={playstore} alt="Google Play" style={{
              width: "200px",
              maxWidth: "50vw",
              height: "auto",
              cursor: "pointer",
              borderRadius: "10px",
              transition: "transform 0.3s ease"
            }} onMouseEnter={e => e.currentTarget.style.transform = "scale(1.1)"} onMouseLeave={e => e.currentTarget.style.transform = "scale(1)"} />
  </a>
</div>

          <p style={{
          color: "#666",
          fontSize: "18px"
        }}>
            Your home, professionally cleaned <br />
            exactly when you need it
          </p>
        </Container>

 <div className="animate__animated animate__fadeInUp d-flex justify-content-center" style={{
        marginTop: "10px",
        marginBottom: "-280px",
        position: "relative",
        zIndex: 10
      }}>
  {/* <img
    src={mobile}
    alt="mobile"
    style={{
      width: "180px",
      maxWidth: "40vw",
    }}
   /> */}

  <div style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          width: "100%",
          padding: "20px 0"
        }}>
<img src={mobile} alt="mobile" style={{
            width: "2000px",
            maxWidth: "40vw",
            height: "240px",
            objectFit: "contain"
          }} />
</div>
</div>
      </section>
      
  <section style={{
      padding: "50px 15px",
      backgroundColor: "#f5f5f5"
    }}>
  <Container>
    <Row className="g-4">
      {services.map((service, index) => <Col lg={4} md={6} sm={12} xs={12} key={index}>
          <Card className="h-100 shadow-sm border-0" style={{
              borderRadius: "16px",
              overflow: "hidden"
            }}>
            <div style={{
                width: "100%",
                height: "250px",
                overflow: "hidden",
                background: "#fff"
              }}>
              <Card.Img variant="top" src={service.image} style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "contain",
                  display: "block"
                }} />
            </div>

            <Card.Body className="text-center" style={{
                padding: "20px"
              }}>
              <Card.Title style={{
                  fontSize: "18px",
                  fontWeight: "600",
                  marginBottom: "0"
                }}>
                {service.title}
              </Card.Title>
            </Card.Body>
          </Card>
        </Col>)}
    </Row>
  </Container>
</section>

  
<section style={{
      padding: "60px 0"
    }}>
  <Container>
    <Row className="mb-5">
      <Col xs={12} md={8}>
        <p style={{
              color: "#6A20Af",
              fontWeight: "600",
              marginBottom: "10px"
            }}>
          SOME OF OUR FEATURES
        </p>

        <h1 style={{
              fontSize: "clamp(28px,4vw,50px)",
              fontWeight: "700"
            }}>
          The <span style={{
                color: "#6A20Af"
              }}>benefits</span> that will
          <br />
          make you comfort.
        </h1>
      </Col>
    </Row>

    <Row className="g-4">
      {features.map((item, index) => <Col key={index} xs={6} sm={4} md={2} lg={2}>
          <Card className="text-center border-0 shadow-sm p-4 h-100">
            <div style={{
                fontSize: "30px",
                color: "#6A20Af",
                marginBottom: "10px"
              }}>
              {item.icon}
            </div>
            <h6>{item.title}</h6>
          </Card>
        </Col>)}
    </Row>
  </Container>
</section>

   
      <section style={{
      background: "#f8f9fa",
      padding: "70px 0",
      fontFamily: "'Montserrat', sans-serif"
    }}>
  <Container>
    <Row className="g-4">
      {stats.map((item, index) => <Col key={index} xs={6} sm={6} md={3} lg={3}>
          <Card className="text-center border-0 h-100 shadow-sm" style={{
              padding: "35px 20px",
              borderRadius: "18px",
              minHeight: "190px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              transition: "0.3s ease"
            }}>
            <div>
              <h1 style={{
                  color: "#6A20Af",
                  fontSize: "clamp(30px, 4vw, 54px)",
                  fontWeight: "800",
                  marginBottom: "12px",
                  fontFamily: "'Montserrat', sans-serif",
                  lineHeight: "1",
                  letterSpacing: "-1px"
                }}>
                {item.number}
              </h1>

              <h5 style={{
                  fontSize: "clamp(14px, 1.8vw, 18px)",
                  fontWeight: "600",
                  color: "#222",
                  margin: "0",
                  fontFamily: "'Montserrat', sans-serif",
                  lineHeight: "1.6"
                }}>
                {item.label}
              </h5>
            </div>
          </Card>
        </Col>)}
    </Row>
  </Container>
</section>
    </>;
}
export default Home;
